import { styled } from '@compiled/react';

import { IconTitleWrapperOldVisualRefresh } from '../IconAndTitleLayout/styled';

// TODO Delete when cleaning platform-linking-visual-refresh-v1
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SpinnerWrapperOldVisualRefresh = styled(IconTitleWrapperOldVisualRefresh)({
	verticalAlign: 'text-bottom',
	padding: '0px',
});
